export {
  PrimaryNavigationLayout,
  type PrimaryNavigationLayoutHandle,
} from "#primary-navigation-layout";
